// src/services/aiService.js
import axios from "axios";

// Simple in-memory cache to avoid repeated AI calls for the same set of messages
const aiCache = new Map();

// Minimum delay between AI calls per conversation (ms)
const AI_CALL_COOLDOWN = 2000;
const lastCallTimestamps = new Map();

/**
 * Generates AI message summarizing top messages from a group
 * @param {string} groupName - name of the sending group
 * @param {string[]} topMessages - array of messages to summarize
 * @param {string} conversationId - unique conversation identifier for rate-limiting
 * @param {string} opponentMessage - the last official message from the opponent group
 */
export const generateAIMessage = async (groupName, topMessages, conversationId = "", opponentMessage = "") => {
  // console.log("Generating AI message for group:", groupName);
  // console.log("Top messages for AI:", topMessages); 
  // console.log("Conversation ID for rate-limiting:", conversationId);
  // console.log("Opponent message:", opponentMessage);
  
  if (!topMessages || topMessages.length === 0) return "";

  const cacheKey = `${conversationId}-${groupName}-${opponentMessage}-${topMessages.join("|")}`;

  // Return cached result if exists
  if (aiCache.has(cacheKey)) {
    return aiCache.get(cacheKey);
  }

  // Rate-limit AI calls per conversation
  const now = Date.now();
  const lastCall = lastCallTimestamps.get(conversationId) || 0;
  if (now - lastCall < AI_CALL_COOLDOWN) {
    return "AI summary pending..."; // placeholder
  }
  lastCallTimestamps.set(conversationId, now);

  try {
    // Call your backend AI summarizer
    const res = await axios.post("/api/weave", {
      groupName,
      messages: topMessages,
      opponentMessage,
    });

    const aiMessage = res.data.message || "Summary unavailable";

    // Cache the result
    aiCache.set(cacheKey, aiMessage);

    return aiMessage;
  } catch (err) {
    console.error("AI summarization error:", err.message);
    return "Error generating AI summary.";
  }
};